import { MetaReducer, createReducer, on } from '@ngrx/store';
import * as moment from 'moment';

import { RocFilter, RocSection } from '@main-application/dashboard-reports/roc-report/interfaces/roc-list-item';
import {
  loadRocReport,
  loadRocReportError,
  loadRocReportSuccess,
  setDisplayedRocSections,
  setRocSorting,
} from '@main-application/dashboard-reports/roc-report/store/roc.actions';
import { hydrationMetaReducer, patchInitialValue } from '@main-application/store/reducers/hydration-meta.reducer';
import { SortItem } from '@shared/interfaces/sort-item';
import { RestTurnoverTaskModel } from '@shared/interfaces/turnover.interface';

import { environment } from '../../../../../../environments/environment';
import { EnvironmentType } from '../../../../../../environments/environment-config';

export const rocFeatureKey = 'roc-report';

export interface RocReportState {
  dataCorrected: boolean;
  reportLoading: boolean;
  report: RestTurnoverTaskModel[];
  propertySorting: { [key: number]: SortItem };
  displayedSections: RocSection[];
  filter: RocFilter;
}

export const initialState: RocReportState = patchInitialValue(
  {
    dataCorrected: false,
    reportLoading: false,
    report: [],
    propertySorting: {},
    displayedSections: [],
    filter: {
      beginDate:
        environment.type === EnvironmentType.Demo
          ? new Date('12/1/2022')
          : moment().add(-3, 'month').startOf('day').toDate(),
      endDate: moment().endOf('day').toDate(),
    },
  },
  rocFeatureKey
);

export const metaRocReducers: Array<MetaReducer<any, any>> = [hydrationMetaReducer<RocReportState>(rocFeatureKey)];

export const reducer = createReducer(
  initialState,
  on(loadRocReport, state => ({
    ...state,
    reportLoading: true,
  })),
  on(loadRocReportSuccess, (state, action) => ({
    ...state,
    ...action,
    reportLoading: false,
  })),
  on(loadRocReportError, state => ({
    ...state,
    report: [],
    reportLoading: false,
  })),
  on(setRocSorting, (state, action) => ({
    ...state,
    ...{ propertySorting: { ...state.propertySorting, ...{ [action.propertyId]: action.sorting } } },
  })),
  on(setDisplayedRocSections, (state, action) => ({
    ...state,
    ...action,
  }))
);
